<template>
  <div>
    <img src="@/assets/404_images/404_cloud.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Demo404',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>